export default "__VITE_ASSET__$OgzJKih__"